import classnames from 'classnames';
import React from 'react';
import { Dropdown, DropdownButton } from 'react-bootstrap';
import { DataBuyerProviderFileLibrary } from './BuyerFileLibrary';
import styles from './dataProviderDropDown.module.scss';
import avatarProvider from 'v2/images/avatarProvider.png';

interface DataProviderDropDownProps {
  list: DataBuyerProviderFileLibrary[];
  selectedProvider: DataBuyerProviderFileLibrary | null;
  onChange: (data: DataBuyerProviderFileLibrary) => void;
}

const DataProviderItem = ({
  dataProvider,
}: {
  dataProvider: DataBuyerProviderFileLibrary;
}) => (
  <>
    <img
      className={classnames('provider-logo', styles.providerLogo)}
      src={
        dataProvider.avatar?.image?.formats?.thumbnail.url ||
        dataProvider.avatar?.image?.url ||
        avatarProvider
      }
      alt="dataProviderLogo"
    ></img>
    {dataProvider.name}
  </>
);

const DataProviderDropDown = ({
  list,
  selectedProvider,
  onChange,
}: DataProviderDropDownProps) => {
  return (
    <DropdownButton
      id="buyerDataFileProviderList"
      title={
        selectedProvider ? (
          <DataProviderItem dataProvider={selectedProvider} />
        ) : (
          ''
        )
      }
      className={classnames(styles.providerSelector)}
    >
      {list.map((item) => (
        <Dropdown.Item
          className={classnames('selectable', styles.providerItem)}
          key={item.id}
          as="div"
          onClick={() => onChange(item)}
        >
          <DataProviderItem dataProvider={item} />
        </Dropdown.Item>
      ))}
    </DropdownButton>
  );
};

export default DataProviderDropDown;
